import React from 'react';

import Tooltip from './Tooltip';
import {cx} from '../util';

const MAX_LOGOS = 3;

// companies: [{id, name, imageUrl}]
const CompanyLogoPile = ({companies = [], max = MAX_LOGOS, className}) => {
  const logos = companies.filter((c) => c.imageUrl).slice(0, max);
  const moreCount = companies.length - logos.length;

  if (logos.length === 0) return null;

  return (
    <Tooltip
      content={(
        <>
          {companies.slice(0, 5).map((c) => <div key={c.id}>{c.name}</div>)}
          {companies.length > 5 && <div>and more</div>}
        </>
      )}
    >
      <span className={cx('inline-flex items-center gap-0.5 text-gray-500', className)}>
        <span className="inline-flex flex-shrink-0 -space-x-1">
          {logos.map((c) => (
            <img
              key={c.id}
              className="h-4 w-4 max-w-none p-px flex-shrink-0 rounded-full object-contain bg-white border border-gray-200 ring-1 ring-white"
              src={c.imageUrl}
              alt=""
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          ))}
        </span>
        {moreCount > 0 && `+${moreCount}`}
      </span>
    </Tooltip>
  );
};

export default CompanyLogoPile;
